<template>
  <div style="display: flex; flex-direction: column;">
    <div
      class="base-detection__container"
      :class="{paired: (!!associatedImageURL && tooltip)}"
      @click="clickImageContainer"
      >
      <img
        v-lazy="baseImageURL"
        class="base-detection__image"
        :class="{selected}"
        :title="imageTitle"
        >
      <transition>
        <img
          v-if="!!associatedImageURL"
          :key="associatedImageURL"
          v-lazy="associatedImageURL"
          class="base-detection__identity-image"
          :style="associatedImageStyle"
        >
      </transition>
    </div>
      <div v-if="showRemove" class="base-detection__button-container">
        <owal-button
          type="none"
          @click="handleClick"
          :title="'Remove'"
          :destructive="true"
          />
      </div>
  </div>
</template>

<script>
import OwalButton from '@/libraries/owal-ui/buttons/OwalButton'

export default {
  name: 'BaseDetection',
  components: { OwalButton },
  props: {
    /** @prop {Object} profile The detection object to display. */
    profile: Object,
    /** @prop {String} associatedIdentity The identifier of the identity the detection is matched with. */
    selected: Boolean,
    /** @prop {Boolean} tooltip Do we show the "remove" tooltip? */
    tooltip: {
      type: Boolean,
      default: false,
    },
    /** @prop {String} baseImageURL URL for the main image displayed */
    baseImageURL: String,
    /** @prop {String} associatedImageURL URL for the associated image */
    associatedImageURL: String,
    /** @prop {String} imageTitle Title to overlay on image */
    imageTitle: String,
    /** @prop {String} associatedImageStyle Override style for associted image */
    associatedImageStyle: String,
    /** @prop {Boolean} showRemove Show remove button */
    showRemove: Boolean,
  },
  methods: {
    handleClick () {
      this.$emit('click')
    },
    clickImageContainer () {
      if (!this.showRemove) {
        this.$emit('click', this.profile.detectionId)
      }
    },
  },
}
</script>

<style scoped>
/** The wrapping div. */
.base-detection__container {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: row;
  margin-bottom: 1.5rem;
}

.base-detection__button-container {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
  margin: -1.25rem auto 1rem;
}

/** The image represented by the detection. */
.base-detection__image {
  background-color: #000;
  object-fit: cover;
  height: 13rem;
  width: 13rem;
  border: 2px solid #fff;
  border-radius: 0.5rem;
  margin: 0;
  z-index: 10;
}

.base-detection__image {
  transform: translateY(0rem);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
}

.base-detection__image,
.base-detection__identity-image {
  transition: border 300ms ease, box-shadow 200ms linear, transform 200ms linear;
}

/** Main image, when the container is hovered */
.base-detection__container:hover .base-detection__image {
  transform: translateY(-2px) scale(1.015);
}

.base-detection__container:hover .base-detection__image,
.base-detection__container:hover .base-detection__identity-image {
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.15);
}

/** When the detection is selected, highlight it. */
.selected {
  border: 3px solid #fff;
  box-shadow: 0 0 2px 2px rgba(0, 128, 0, 0.25);
  transition: box-shadow 300ms ease;
}

/** Slide detection up slightly when hovered. */
.selected:hover {
  transform: translateY(-2px);
}

.selected + .base-detection__identity-image {
  border: 3px solid #fff;
  box-shadow: 0 0 2px 2px rgba(0, 128, 0, 0.25);
}

/** If there is an associated ID (i.e. it's selected) show the image in small. */
.base-detection__identity-image {
  position: relative;
  justify-self: flex-end;
  align-self: flex-end;
  height: 5rem;
  width: 5rem;
  background: #fff;
  margin-left: -5rem;
  border-radius: 50%;
  transform: translateX(0.75rem) translateY(0.75rem);
  transform-origin: bottom right;
  border: 2px solid #fff;
  object-fit: cover;
  box-shadow: 0 0 1px 1px rgba(0, 128, 0, 0.15);
  z-index: 11;
}

.paired:hover .base-detection__image,
.paired:hover .base-detection__identity-image {
  box-shadow: 0 0 2px 2px rgba(128, 0, 0, 0.15);
}

/** The outermost container when paired.  */
.paired::after {
  opacity: 0;
  content: 'Click to Remove';
  background-color: #ee0000aa;
  color: #fff;
  position: relative;
  justify-self: flex-end;
  align-self: flex-end;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: fit-content;
  width: 11rem;
  padding: 1.25rem 0 0.5rem 0;
  box-sizing: border-box;
  z-index: 9;
  margin-left: -11rem;
  transform: translateX(-1rem) translateY(-0.75rem);
  border-radius: 0.5rem;
  transition: all 300ms ease;
  font-weight: bold;
}

.paired:hover::after {
  opacity: 1;
  transform: translateX(-1rem) translateY(2rem);
  transition: all 300ms ease;
}

/** Appear animation. */

.v-enter-active {
  animation-name: appear;
  animation-duration: 200ms;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.v-leave-active,
.v-leave-to {
  animation-name: appear;
  animation-duration: 450ms;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation-direction: reverse;
}

@keyframes appear {
  from {
    opacity: 0;
    transform: scale(0.1) translateX(0.75rem) translateY(0.75rem);
  }

  to {
    opacity: 1;
    transform: scale(1) translateX(0.75rem) translateY(0.75rem);
  }
}
</style>
